import React from 'react'
import "./style.scss";
import Navbar from '../../components/Navbar';
import { Box, Container, Grid, Typography } from '@mui/material';
import Button from '../../components/Button';
import GradientText from '../../components/GradientText';
import CenterBox from '../../components/CenterBox';
import Footer from '../../components/Footer';
import Link from "../../components/Link";
import FractalLogo from "../../assets/logos/fractal.png"
import Coin98Logo from "../../assets/logos/coin98.png"
import LupaxLogo from "../../assets/logos/lupax.png"
import ParsiqLogo from "../../assets/logos/parsiq.png"
import M6Logo from "../../assets/logos/m6.png"
import PlethoriLogo from "../../assets/logos/plethori.png"
import OrionLogo from "../../assets/logos/orion.png"
import ScryptLogo from "../../assets/logos/scryptictech.png"
import X21Logo from "../../assets/logos/x21.png"
import BlockSyncLogo from "../../assets/logos/blocksync.png"
import ChainlinkLogo from "../../assets/logos/chainlink.png"
import GenesisLogo from "../../assets/logos/genesis.png"

export default function Home() {
  return (
    <Box className="home-box">
      <Container className="home-container">
        <Navbar />
        <GradientText className="animated-text" sizesmall={30} size={60} top={110} topsmall={40}>
          WE OFFER THE LOWEST RATES FOR YOUR LAUNCH
        </GradientText>
        <CenterBox>
          <Link href="https://app.orbpad.finance/" target="_blank"><Button className="apply-btn" text="LAUNCH APP" /></Link>
        </CenterBox>
        <Typography className='outline-text'>ORBPAD launchpad</Typography>
        <GradientText sizesmall={24} size={60} className="subtitle">
          Why ORBPAD ?
        </GradientText>
        <Grid container className="nasalization">
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Typography className="card-title">Standard</Typography>
            <Typography className='card-text montserrat'>Create standard tokens on Orb3.</Typography>
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <Typography className="card-title">Deflationary</Typography>
            <Typography className='card-text montserrat'>Create deflationary tokens with tax and/or charity functions.</Typography>
          </Grid>
          <Grid item lg={4} md={12} sm={12} xs={12}>
            <Typography className="card-title">Customization</Typography>
            <Typography className='card-text montserrat' sx={{ marginBottom: "0 !important" }}>Create a token sale for your own custom token easily.</Typography>
          </Grid>
        </Grid>
        <Grid container className="section-detail">
          <Grid item md={6} sm={12} xs={12}>
            <dotlottie-player class="detail-image" src="https://lottie.host/b37d7327-08e3-4f78-9c7e-bc5673f8c7f6/Gk0e0eSdK5.json" background="transparent" speed="1" loop autoplay></dotlottie-player>
          </Grid>
          <Grid item md={6} sm={12} xs={12}>
            <Typography className="detail-title">Fastest project launch at the lowest cost</Typography>
            <Typography className='detail-text montserrat'>1. We provide a fast, reliable and secure platform to launch crypto projects and manage them.</Typography>
            <Typography className='detail-text montserrat'>2. Crypto investors can also use our technology to get access to the best Crypto and Defi projects.</Typography>
          </Grid>
        </Grid>
        <Grid container className="section-detail reverse">
          <Grid item md={6} sm={12} xs={12}>
            <Typography className="detail-title">token minting without hassles</Typography>
            <Typography className='detail-text montserrat'>1. As a crypto project, you can easily create and customize your cryptocurrency with our mining feature..</Typography>
            <Typography className='detail-text montserrat'>2. Crypto investors can also use our technology to get access to the best Crypto and Defi projects.</Typography>
          </Grid>
          <Grid item md={6} sm={12} xs={12}>
            <dotlottie-player class="detail-image" src="https://lottie.host/163f52d0-4f4a-4276-b7b2-27a84ce139e5/RCbo5WnX3o.json" background="transparent" speed="1" loop autoplay></dotlottie-player>
          </Grid>
        </Grid>
        <Grid container className="section-detail">
          <Grid item md={6} sm={12} xs={12}>
            <dotlottie-player class="detail-image" src="https://lottie.host/20ed9b88-f517-4bb1-a97c-cde0ee936588/zgNPPqtTxC.json" background="transparent" speed="1" loop autoplay></dotlottie-player>
          </Grid>
          <Grid item md={6} sm={12} xs={12}>
            <Typography className="detail-title">secure, transparent and trustworthy</Typography>
            <Typography className='detail-text montserrat'>Project owners are welcome to use our lock feature to lock their liquidity pool tokens in order to enhance the community's confidence in the project.</Typography>
          </Grid>
        </Grid>
        <GradientText sizesmall={24} size={60} className="subtitle">
          Corporate Partners
        </GradientText>
        <Grid container className="justify-center partners">
          <Grid item md={2} sm={3} xs={4}><img src={FractalLogo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={Coin98Logo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={LupaxLogo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={ParsiqLogo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={M6Logo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={PlethoriLogo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={OrionLogo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={ScryptLogo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={X21Logo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={BlockSyncLogo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={ChainlinkLogo} alt="partners" /></Grid>
          <Grid item md={2} sm={3} xs={4}><img src={GenesisLogo} alt="partners" /></Grid>
        </Grid>
      </Container>
      <Footer />
    </Box >
  )
}
